/* src/app/opportunities/partials/opportunity-form/opportunity-form.component.scss */
/*# sourceMappingURL=opportunity-form.component.css.map */
